import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { NAVIGATION } from 'src/reducers/nav/types';

// import { SYSTEM_MESSAGE } from 'Constants/modalTypes';

// This will take incoming page navigation and dispatch it to the redux store
// logic will be able to use this to show what needs to be drawn

let lastHandled = new Date();
let initialized = false;
const _handlePage = ctx => {
  if (ctx.timing < lastHandled) {
    log.debug('tried to handle a page out of order');
    return;
  }
  store.dispatch({
    type: NAVIGATION,
    context: ctx
  });

  // This block will make sure that the location is set in the store BEFORE
  // any component try to read that
  if (!initialized) {
    mediator.publish('app:ready', {
      nav: true
    });
    initialized = true;
  }
  lastHandled = ctx.timing;

  // This next chunk of code is used to display system message modals based on where the user
  // navigated to.
  // const {
  //   auth: { loggedIn },
  //   config: { systemMessages },
  //   nav: { location },
  //   user: { accountType, system },
  // } = store.getState();

  // if (!loggedIn) {
  //   return;
  // }

  // const dismissed = system.messages || {};

  // const navigationMessages = Object.values(systemMessages[accountType]).filter(
  //   (m) => m.type === 'navigation' && !dismissed[m.id]
  // );

  // if (navigationMessages) {
  //   const message = navigationMessages.find((m) =>
  //     location.toLowerCase().startsWith(m.uriTrigger.toLowerCase())
  //   );

  //   if (message) {
  //     store.dispatch({ type: DRAW_MODAL, modal: SYSTEM_MESSAGE, props: { message } });
  //   }
  // }
};
mediator.subscribe('page', _handlePage);